export const GA_TRACKING_ID = 'G-LBYMQ27E8N'

/* global gtag */
export const scheduleEvent = (purchaseDetails) => {
  const { scheduling, isReactNative } = purchaseDetails

  gtag('event', 'agendamento_servico', {
    id: scheduling.id,
    value: scheduling.price,
    service_category: scheduling.service.category,
    service_name: scheduling.service.name,
    web_platform: isReactNative ? 'webapp' : 'web',
    payment_flow: scheduling.payments?.online ? 'pagamento online' : 'Pague diretamente no local',
    service_store: scheduling.partner.fantasyName
  })
}

export const serviceClickEvent = (serviceName) => {
  gtag('event', 'select_service_type', {
    event_label: serviceName
  })
}

export const flowOptionClickEvent = (flowType, serviceCategory) => {
  let serviceCategoryToGtag

  switch (serviceCategory) {
    case 'BANHO_TOSA':
      serviceCategoryToGtag = 'Banho'
      break
    case 'CLINICA_VET':
      serviceCategoryToGtag = 'Vet'
      break
    default:
      serviceCategoryToGtag = ''
      break
  }

  gtag('event', 'select_schedule_type', {
    event_label: `${flowType} - ${serviceCategoryToGtag}`
  })
}

export const viewBannerEvent = (bannerParam) => {
  if (!bannerParam) {
    console.warn('viewBannerEvent: bannerParam nao informado')
    return
  }

  try {
    gtag('event', 'view_promotion', {
      creative_name: bannerParam,
      promotion_name: bannerParam
    })
  } catch (error) {
    console.error(error)
  }
}
